import { createReducer, on } from '@ngrx/store';
import {
  login,
  logout,
  refresh,
  remember,
  setUserAuthorities,
  setUserClient,
  setUserPermissions,
  setUserProfile,
  updateProfileSuccess,
} from './auth.actions';
import { hydrateSuccess } from '@store/storage.actions';
import { AuthorityDto, ClientDto, PermissionDto, ProfileDto } from '@shared/dto';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState {
  rememberMe: boolean;
  access: string | null;
  refresh: string | null;
  device: string | null;
  profile: ProfileDto | null;
  client: ClientDto | null;
  authorities: AuthorityDto[];
  permissions: PermissionDto[];
}

export const initialState: AuthState = {
  rememberMe: true,
  access: null,
  refresh: null,
  device: null,
  profile: null,
  client: null,
  authorities: [],
  permissions: [],
}

export const authReducer = createReducer(
  initialState,
  on(remember, (state, payload) => ({...state, ...payload})),
  on(login, (state, payload) => ({...state, ...payload})),
  on(refresh, (state, payload) => ({...state, ...payload})),
  on(setUserProfile, (state, payload) => ({...state, ...payload})),
  on(updateProfileSuccess, (state, { profile }) => ({ ...state, profile })),
  on(setUserClient, (state, payload) => ({...state, ...payload})),
  on(setUserAuthorities, (state, payload) => ({...state, ...payload})),
  on(setUserPermissions, (state, payload) => ({...state, ...payload})),
  on(hydrateSuccess, (state, payload) => ({...state, ...payload.state.auth})),
  on(logout, () => initialState),
);
